<div id="nav">
  <button class="flex f_align_c gap_10 nav-logo-container" (click)="nav.to('/')">
    @if(api.userRole.isWorker && api.env.type === DocumentType.ZWEVISA) {
      <img class="nav-logo" src="assets-projects/bms-full.svg"/>
      <div [matTooltip]="api.isZwevisa ? ('tooltip.syncing' | translate) : ''" class="sync-global" *ngIf="cart.syncQueue?.length && api.hasPerm(UserPermission.ALLOW_CONSUME) && api.userRole.isWorker">
        <app-paragraph class="fullWidth">{{('global.syncing' | translate) + ' (' + cart.syncQueue.length + ')'}}</app-paragraph>
        <svg viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5" style="stroke: black; stroke-opacity: 0.5;"/>
        </svg>
      </div>
    } @else {
      <img class="nav-logo" src="assets-projects/logo-full.png"/>
    }
  </button>
  <div class="flex gap_5">
    <app-button *ngIf="!api.userRole?.isCustomer" color="secondary" size="xs" icon="qrcode" (btnClicked)="clickScan()" [matTooltip]="api.env.type === DocumentType.ZWEVISA ? ('tooltip.Qr' | translate) : ''">{{'payments.scan' | translate}}</app-button>
    <ng-container *ngFor="let item of data">
      <div class="nav_item" *ngIf="item.guard && (item.perm ? api.hasPerm(item.perm) : true)" [matTooltip]="(api.env.type === DocumentType.ZWEVISA && item?.tip) ? (item.tip | translate) : ''">
          <app-button [borderXs]="true" color="secondary" [class.bold]="item.route === router.url" size="xs" (btnClicked)="item.route ? nav.to(item.route) : item.action ? item.action() : undefined">
            <fa-icon *ngIf="item.icon" [icon]="item.icon"></fa-icon>
            {{item.label | translate}}
          </app-button>
      </div>
  </ng-container>
  <app-snackbar *ngIf="api.userInfo" class="cursor-pointer" (click)="nav.to('my-account')" [matTooltip]="api.env.type === DocumentType.ZWEVISA ? ('tooltip.role' | translate) : ''">{{api.userInfo.name + ' | ' + (('form.role.'+userRoles[api.userInfo.role] | lowercase) | translate)}}</app-snackbar>
  </div>
</div>
